import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      100: "#00A9E0", // Bright Sky Blue
      light: "#03A9F4", // Light Blue
      main: "#fd0b0b", // Medium Blue
      dark: "#01579B", // Dark Blue
    },
    secondary: {
      light: "#B0BEC5", // Muted Blue-Gray
      main: "#607D8B", // Medium Gray-Blue
      dark: "#455A64", // Dark Gray-Blue
      white: "#FFFFFF", // White for text and backgrounds
    },
    accent: {
      light: "#FFEBEE", // Light Pink
      main: "#F50057", // Bright Pink
      dark: "#C51162", // Deep Magenta
    },
    background: {
      default: "#F5F5F5", // Very light gray background
      paper: "#FFFFFF", // White for cards and modals
      dark: "#121212", // Dark gray background for dark mode
    },
    text: {
      primary: "#212121", // Dark gray for readability
      secondary: "#757575", // Medium gray for subdued text
      light: "#E0E0E0", // Light gray for dark mode
    },
    border: {
      light: "#E0E0E0", // Light gray border color
      dark: "#333333", // Dark gray border color
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    h1: {
      fontFamily: '"Merriweather", serif',
    },
    h2: {
      fontFamily: '"Merriweather", serif',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "1rem",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#616161", // Neutral icon color
          "&.MuiSvgIcon-colorPrimary": {
            color: "#0288D1", // Primary icon color
          },
          "&.MuiSvgIcon-colorSecondary": {
            color: "#455A64", // Secondary icon color
          },
          "&.MuiSvgIcon-colorError": {
            color: "#D32F2F", // Error icon color
          },
          "&.MuiSvgIcon-colorSuccess": {
            color: "#388E3C", // Success icon color
          },
        },
      },
    },
  },
});

export default theme;
